import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarService } from '../../services/snack-bar.service';
import { activeTranslations } from '../../enum/constants';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snack-bar.component.html',
  styleUrl: './snack-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SnackBarComponent {
  public files: any[] = [];
  public isExpanded: boolean = true;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBarRef: MatSnackBarRef<SnackBarComponent>,
    private snackBarService: SnackBarService,
  ) {
    this.files = data;
  }

  addFile(fileData: any) {
    this.files.unshift(fileData);
  }

  updateProgress(fileId: string, progress: number) {
    const file = this.files.find((f: any) => f.id === fileId);
    if (file) {
      file.progress = progress;
    }
  }

  setStatus(fileId: string, status: string) {
    const file = this.files.find((f: any) => f.id === fileId);
    if (file) {
      file.status = status;
    }
  }

  setErrorType(fileId: string, errorType: string) {
    const file = this.files.find((f: any) => f.id === fileId);
    if (file) {
      file.errorType = errorType;
    }
  }

  getStatusText(): string {
    const lang = activeTranslations;

    const activeFiles = this.files.filter((f) => f.progress < 100 && !f.error).length;
    const completedFiles = this.files.filter((f) => f.progress === 100).length;
    const failedFiles = this.files.filter((f) => f.status === 'error').length;

    let status: string;

    if (activeFiles > 0) {
      status = lang.snack_bar.in_progress.replace('{count}', activeFiles);
    } else {
      status = lang.snack_bar.completed.replace('{count}', completedFiles);

      if (failedFiles > 0) {
        status += lang.snack_bar.failed.replace('{count}', failedFiles);
      }
    }

    return status;
  }

  closeSnackBar() {
    this.snackBarRef.dismiss();
    this.snackBarService.close();
  }

  toggleFilesVisibility() {
    this.isExpanded = !this.isExpanded;
  }
}
